import { render, staticRenderFns } from "./AddPnr.vue?vue&type=template&id=3d2c4b24&scoped=true"
import script from "./AddPnr.vue?vue&type=script&lang=js"
export * from "./AddPnr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2c4b24",
  null
  
)

export default component.exports